import React, {useContext, useRef} from 'react';
import OwlCarousel from "react-owl-carousel2";
import 'react-owl-carousel2/lib/styles.css';
import {ScrollToPosition} from "../../utils/ScrollToPosition";
import {PopupSliderContext} from "../../App";

const HorizontalSlider = ({gallery}) => {
    const refSlider = useRef(null);
    const [, setPopupSliderContext] = useContext(PopupSliderContext);

    const options = {
        items: document?.querySelector('.background')?.classList?.contains('lottery') ? 5 : 4,
        nav: true,
        margin: 19,
        loop: false,
        dots: false,
        rewind: true,
        lazyLoad: true,
        center: false,
        navText: [],
    };

    const item = {
        items: gallery.map((item, i) => <div className="gallery-item" key={item.prev_image}>
            <a
                href={item.prev_image}
                onClick={(e) => {
                    e.preventDefault();
                    ScrollToPosition(false, window.pageYOffset);
                    setPopupSliderContext({list: gallery, active: i})
                }}
            >
                <img src={item.prev_image} alt=''/>
            </a>
        </div>)
    };

    return (
        <div className="container">
            {document.body.clientWidth > 1366 ?
                <OwlCarousel
                    ref={refSlider}
                    options={options}
                    touch-action="pan-y"
                    className="gallery-carousel owl-carousel owl-theme"
                >{item.items}</OwlCarousel>
                : <div className='gallery-carousel owl-carousel owl-theme popup-gallery'>
                    {item.items}
                    {[...Array(10)].map((item) => <div className="gallery-item null_height"></div>)}
                </div>}
        </div>
    );
};

export default HorizontalSlider;